"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("@/services/components");
const components_2 = require("@/store/ducks/components");
const listComponentsUseCase_1 = require("./listComponentsUseCase");
function updateComponentUseCase(componentId, componentData) {
    return async (dispatch) => {
        dispatch((0, components_2.saveChanges)());
        try {
            await (0, components_1.updateComponent)(componentId, componentData);
            dispatch((0, components_2.saveChangesSuccess)());
            dispatch((0, components_2.openComponentToast)());
            await (0, listComponentsUseCase_1.listComponents)()(dispatch);
            dispatch((0, components_2.closeEditComponentModal)());
        }
        catch (error) {
            dispatch((0, components_2.saveChangesError)());
            dispatch((0, components_2.openComponentToast)());
        }
    };
}
exports.default = updateComponentUseCase;
